import { ObservableFromFetch } from "../ObservableFromFetch"

export default function UserRevoke(applicationUserId: number) {
  const requestBody: string = new URLSearchParams({
    applicationUserId: applicationUserId.toString()
  }).toString()

  return ObservableFromFetch<string>("FFOrderUserFileMaintenance/RevokeUser?" + requestBody)
}